module.exports = "//static.hsappstatic.net/ui-forms-components/static-1.6714/img/properties/matrix-scale.png"